import { CreateOperation } from 'modules/Rest'
import { MessageContext } from './Contexts'
import React, { useContext, useState } from 'react'
import AButton from './AButton'

export default function StartTaskButton({ args, url, stage_label, buttonText, whenDone, buttonTimeout = true, ...props }) {
  const { setNotificationBarOpen, messageDispatch } = useContext(MessageContext)
  const [enabled, setEnabled] = useState(true)

  return (
    <AButton
      color='primary'
      disabled={!enabled}
      onClick={async () => {
        try {
          setEnabled(false)
          if (buttonTimeout) setTimeout(() => setEnabled(true), 5000)
          const { data: { success, info } } = await CreateOperation({ ...args, url, stage_label }, messageDispatch)
          if (success) {
            setNotificationBarOpen(true)
            if (whenDone) whenDone()
          } else {
            throw new Error(info ? info : 'An error occurred')
          }
        } catch (error) {
          messageDispatch({type: 'warning', payload: error.message})
        }
      }}
      {...props}
    >
      {buttonText}
    </AButton>
  )
}
